module.exports = __webpack_public_path__ + "static/media/enterprise-hover.2ceb4485.svg";